import * as React from 'react';
import {Tabs, TabList, TabPanels, TabPanel, Tab} from '@sail/ui';
import {ExamplePanel} from './utils';
import {ResizableContainer} from '../common/ResizableContainer';

export const Basic = () => (
  <ResizableContainer minWidth={150} width={500} maxWidth={800}>
    <Tabs fitted>
      <TabList>
        {[1, 2].map((i) => (
          <Tab key={i}>Tab {i}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {[1, 2].map((i) => (
          <TabPanel key={i}>
            <ExamplePanel>Tab panel {i}</ExamplePanel>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  </ResizableContainer>
);
